module.exports = __webpack_public_path__ + "static/img/幡.5f05c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/幡.png
// module id = Juom
// module chunks = 4